import * as React from 'react';
import styled from 'styled-components';
import { IconStyle } from '../Icon.styles.js';
const _IconControlStar = (props) => {
    const { 'data-test-id': dataTestId, className, size, style, ...rest } = props;
    return (React.createElement("span", { "data-test-id": dataTestId, className: className, style: style }, size === '24'
        ? React.cloneElement(React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { fillRule: "evenodd", d: "M15.232 8.05 12 1.5 8.767 8.05 1.538 9.1l5.23 5.1-1.234 7.2L12 18l6.465 3.4-1.235-7.2 5.231-5.1-7.228-1.05Zm4.006 2.098-5.002-.727L12 4.89 9.763 9.421l-5.001.727 3.619 3.528-.855 4.981L12 16.305l4.473 2.352-.854-4.981 3.619-3.528Z", fill: "currentColor" })), { width: 24, height: 24, ...rest })
        : React.cloneElement(React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
            React.createElement("path", { fillRule: "evenodd", d: "M10.13 5.567 8 1.25 5.87 5.567l-4.765.693 3.447 3.36-.813 4.745L8 12.125l4.261 2.24-.813-4.745 3.447-3.36-4.764-.693Zm1.542 1.74-2.537-.369L8 4.64l-1.135 2.3-2.537.368 1.836 1.79-.433 2.526L8 10.43l2.27 1.193-.434-2.526 1.836-1.79Z", fill: "currentColor" })), { width: 16, height: 16, ...rest })));
};
const defaultProps = {
    size: '24',
};
export const IconControlStar = styled(_IconControlStar) `
    ${IconStyle}
`;
IconControlStar.defaultProps = defaultProps;
//# sourceMappingURL=IconControlStar.js.map